



import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';

const SalonByCategory = () => {
    const { categoryId, categoryName } = useParams();
    const [salons, setSalons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [allTimings, setAllTimings] = useState([]); // New state for timings
    const navigate = useNavigate();
    const THEME_COLOR = '#065f46';

    // Helper: Format 24h to 12h AM/PM
    const formatTime12h = (timeStr) => {
        if (!timeStr) return '---';
        try {
            let [hours, minutes] = timeStr.split(':');
            let h = parseInt(hours, 10);
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12;
            return `${h.toString().padStart(2, '0')}:${minutes} ${ampm}`;
        } catch (e) { return timeStr; }
    };

    // Helper: Get Today's Day ID (0-6)
    const currentDayId = new Date().getDay();

    useEffect(() => {
        window.scrollTo(0, 0);
        loadSalonsByServiceName();
    }, [categoryName]);

    const loadSalonsByServiceName = async () => {
        setLoading(true);
        try {
            // Added GETALLTIMINGS to the concurrent requests
            const [salonRes, serviceRes, timingRes] = await Promise.all([
                axios.get(`${config.APIACTIVEURL}${config.GETALLSALON}`),
                axios.get(`${config.APIACTIVEURL}${config.GETSERVICETYPE}`),
                axios.get(`${config.APIACTIVEURL}${config.GETALLTIMINGS}`)
            ]);

            const allSalons = salonRes.data || [];
            const allServices = serviceRes.data?.data || serviceRes.data?.items || serviceRes.data || [];
            const timingData = timingRes.data || [];

            setAllTimings(timingData);

            const matchedServices = allServices.filter(service => {
                const searchLower = categoryName.toLowerCase();
                const serviceName = (service.name || "").toLowerCase();
                const serviceCategory = (service.category || "").toLowerCase();
                return serviceName.includes(searchLower) || serviceCategory === searchLower;
            });

            const validSalonIds = [...new Set(matchedServices.map(s => s.salonId))];
            const filtered = allSalons.filter(s => validSalonIds.includes(s.salonId));
            
            setSalons(filtered);
        } catch (error) {
            console.error("Error filtering salons", error);
        } finally {
            setLoading(false);
        }
    };

    const handleBookAppointment = (e, salonId) => {
        e.stopPropagation(); 
        navigate(`/book-service?salonId=${salonId}`); 
    };

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '120px' }}>
            <div className="container py-5">
                <div className="mb-5">
                    <Link to="/" className="text-decoration-none fw-bold" style={{ color: THEME_COLOR }}>
                        <i className="ri-arrow-left-line"></i> Back to Home
                    </Link>
                    <h1 className="display-6 fw-bold mt-2" style={{ color: '#064e3b' }}>
                        Salons offering "{categoryName}"
                    </h1>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border" style={{ color: THEME_COLOR }}></div>
                    </div>
                ) : (
                    <div className="row g-4">
                        {salons.length > 0 ? salons.map(salon => {
                            // Find the timing for this salon for today
                            const todayTiming = allTimings.find(t => t.salonId === salon.salonId && t.dayOfWeek === currentDayId);

                            return (
                                <div className="col-md-6 col-lg-4" key={salon.salonId}>
                                    <div 
                                        className="card border-0 shadow-sm h-100" 
                                        style={{ borderRadius: '1.5rem', cursor: 'pointer' }}
                                        onClick={() => navigate(`/salon-details/${salon.salonId}`)}
                                    >
                                        <img 
                                            src="/assets/salonimage.jpg" 
                                            className="card-img-top" 
                                            style={{ height: '220px', objectFit: 'cover', borderRadius: '1.5rem 1.5rem 0 0' }} 
                                            alt="Salon Thumbnail" 
                                            onError={(e) => { e.target.src = 'https://via.placeholder.com/400x250?text=Salon'; }}
                                        />
                                        
                                        <div className="card-body p-4">
                                            {/* Today's Timing Badge */}
                                            <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom border-light">
                                                <span className="fw-bold text-uppercase text-muted" style={{fontSize: '0.65rem'}}>Today's Hours</span>
                                                {todayTiming ? (
                                                    todayTiming.isClosed ? (
                                                        <span className="badge bg-danger-subtle text-danger rounded-pill px-2">Closed</span>
                                                    ) : (
                                                        <span className="fw-bold" style={{ color: THEME_COLOR, fontSize: '0.75rem' }}>
                                                            <i className="ri-time-line me-1"></i>
                                                            {formatTime12h(todayTiming.openTime)} - {formatTime12h(todayTiming.closeTime)}
                                                        </span>
                                                    )
                                                ) : (
                                                    <span className="text-muted small italic" style={{fontSize: '0.65rem'}}>Not set</span>
                                                )}
                                            </div>

                                            <h5 className="fw-bold mb-1">{salon.name || salon.salonName}</h5>
                                            <p className="text-muted small mb-3">
                                                <i className="ri-map-pin-line"></i> {salon.address || 'Address not listed'}
                                            </p>
                                            <button 
                                                className="btn w-100 rounded-pill fw-bold" 
                                                style={{ border: `1px solid ${THEME_COLOR}`, color: THEME_COLOR }}
                                                onClick={(e) => handleBookAppointment(e, salon.salonId)}
                                            >
                                                Book Appointment
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        }) : (
                            <div className="text-center py-5 w-100">
                                <h4 className="text-muted">No salons found for "{categoryName}".</h4>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SalonByCategory;